import * as httpHelper from '../httpHelper';//网络助手
import { httpUrl } from 'service/api/httpUrl.js'
import {isNoNullAll} from 'utils/js/mixin.js'


/**
 *默认播放背景图
 */
export function getdefaultImg(params){
  return httpHelper.get('getdefaultImg',params)
}

/**
 *热门推荐、最新推荐
 */
export function getresList(params){
  return httpHelper.get('getresList',params)
}

/**
 *统计
 */
export function getstatisticList(params){
  return httpHelper.get('getstatisticList',params)
}

/**
 *直播预告列表
 */
export function getpageList(params){
  return httpHelper.get('getpageList',params)
}


/**
 *默认播放列表
 */
export function getVideoList(params){
  return httpHelper.get('getVideoList',params)
}


/**
 *查询资源库详情
 */
export function resourceDetail(params){
  return httpHelper.get('resourceDetail',params)
}

/**
 *点赞
 */
export function praiseFunc(params){
  return httpHelper.post('praiseFunc',params)
}

/**
 *收藏
 */
export function collectFunc(params){
  return httpHelper.post('collectFunc',params)
}

/**
 *下载
 */
export function downloadFiles(params){
  return httpHelper.get('downloadFiles',params)
}


/**
 *我的收藏
 */
export function getmyCollect(params){
  return httpHelper.get('getmyCollect',params)
}


/**
 *浏览记录
 */
export function getbrowseRecord(params){
  return httpHelper.get('getbrowseRecord',params)
}


/**
 *删除浏览记录
 */
export function delBrowseRecord(params){
  return httpHelper.post('delBrowseRecord',params)
}